<template>
  <div class="default-component">
    <dev-only><h2>[dev-hint] Component not found</h2></dev-only>
  </div>
</template>
